module.exports = __webpack_public_path__ + "static/media/ensuenio-lugar.c6ffb296.mp4";